// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_BqW","cls2":"FilterPanel-cls2_5DD FilterPanel-cls1_BqW","open":"FilterPanel-open_oQU"};